export default __webpack_public_path__ + "static/media/Esther 9781408342688.ba8cc698.jpg";